



































































































import {Component, Vue} from "vue-property-decorator";
import TextBox from "@/components/TextBox.vue";
import ImageText from "@/components/ImageText.vue";
import Quote from "@/components/Quote.vue";
import PathBox from "@/components/PathBox.vue";
import Player from "@/components/Player.vue";
import VideoBox from "@/components/VideoBox.vue";
import ImageGrid from "@/components/ImageGrid.vue";
import LogoBox from "@/components/LogoBox.vue";
import HeadingDivider from "@/components/HeadingDivider.vue";
import {RouterStore} from "@/interfaces/store-interfaces/router-store.interface";
import {MainPageConfig} from "@/interfaces/main-page.interface";
import VideoContent from "@/components/VideoContent.vue";
import {ThemePathPageConfig} from "@/interfaces/theme-path-page.interface";
import {bus} from "@/plugins/bus";
import {EventEmitter} from "@/interfaces/store-interfaces/event-emitter.interface";
import {AboutPageConfig} from "@/interfaces/about-page.interface";
import Button from "@/components/Button.vue";
import ContentPage from "@/components/ContentPage.vue";
import VideoSync from "@/components/VideoSync.vue";
import WordCloud from "@/components/WordCloud.vue";

@Component({
  components: {
    HeadingDivider,
    LogoBox,
    ImageGrid,
    VideoBox,
    VideoContent,
    TextBox,
    ImageText,
    Quote,
    PathBox,
    Player,
    Button,
    ContentPage,
    VideoSync,
    WordCloud,
  }
})

export default class DefaultPage extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;
  isLoading = true;
  blockTypes = MainPageConfig.PageBlockTypes;
  filmViewModes = ThemePathPageConfig.FilmViewModes;
  pageContent: AboutPageConfig.IAboutPageConfig;

  async created() {
    this.pageContent = await this.$store.dispatch("contentPage/getPageContent", {page: this.$router.currentRoute.name});
    this.isLoading = false;
    setTimeout( () => {
      bus.$emit(EventEmitter.Events.DATA_LOADED);
    })
  }
}
